export default __webpack_public_path__ + "static/media/EAST0560.34I-29080_-16917_0.88d86324.jpg";